import React, { useState } from 'react'

import makeStyles from '@material-ui/core/styles/makeStyles'

import { CatalogItemProps, CatalogsByQueryInput } from 'src/contexts/discovery'
import { useCatalogHighlighting } from 'src/contexts/discovery/useCatalogHighlighting'
import { useParsedSearchParams } from 'src/utils/searchparams'

import { hitKeyDataCatalog } from '../../config'
import { excludeField } from '../../utils/excludeField'
import { ContentEntry } from './ContentEntry'
import { FullTextHighlight } from './FullTextHighlight'

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  textual: {
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface CatalogContentProps {
  catalog: CatalogItemProps
  index?: number
}

export function CatalogContent({
  catalog,
  index,
}: Readonly<CatalogContentProps>) {
  const cls = useStyles()
  const { q } = useParsedSearchParams()
  const [highlighting, setHighlighting] = useState<string[]>()

  const queryInput = {
    q,
    start: index,
  } as CatalogsByQueryInput

  const { refetch: refetchHighlighting, isFetching: loading } =
    useCatalogHighlighting(catalog.id, queryInput, setHighlighting)

  const handleContextLoading = () => {
    refetchHighlighting()
  }

  return (
    <div className={cls.content}>
      <div className={cls.textual}>
        {hitKeyDataCatalog.map((field) => {
          const isExcluded = excludeField(catalog, field)
          const isFulltextWithoutQuery = field.includes('fulltext') && !q

          if (isExcluded || isFulltextWithoutQuery) return null

          if (field.includes('fulltext')) {
            return (
              <FullTextHighlight
                key={field}
                highlighting={highlighting}
                loading={loading}
                handleContextLoading={handleContextLoading}
              />
            )
          }

          return <ContentEntry catalog={catalog} field={field} key={field} />
        })}
      </div>
    </div>
  )
}
